import { useEffect, useState } from 'react';
import { fetchMyQuota, type QuotaData } from '../services/adminService';

/** 额度刷新间隔，与 CanvasQuota 保持一致。 */
export const MY_QUOTA_REFRESH_INTERVAL_MS = 20_000;

/**
 * 读取当前用户今日额度。
 *
 * 与 CanvasQuota 共用同一个接口但互不依赖，避免为了一个提示去重构既有组件。
 * `enabled` 为 false 时不发请求（例如管理员或未登录）。
 */
export function useMyQuota(enabled: boolean): QuotaData | null {
  const [quota, setQuota] = useState<QuotaData | null>(null);

  useEffect(() => {
    if (!enabled) {
      setQuota(null);
      return;
    }

    let active = true;
    const load = async () => {
      try {
        const data = await fetchMyQuota();
        if (active) setQuota(data);
      } catch {
        // 额度只用于提示，失败时静默降级，不打扰用户。
      }
    };

    void load();
    const timer = window.setInterval(() => void load(), MY_QUOTA_REFRESH_INTERVAL_MS);
    const onFocus = () => void load();
    window.addEventListener('focus', onFocus);

    return () => {
      active = false;
      window.clearInterval(timer);
      window.removeEventListener('focus', onFocus);
    };
  }, [enabled]);

  return quota;
}